export default __webpack_public_path__ + "static/media/app-bg.ba365263.jpg";